<template>
    <div class="tool-list-wrapper">
        <EmptyPage :height="588" :loading="loading" v-if="list.length === 0" />
        <div v-else>
            <div class="tool-list">
                <div class="tool-list__item" v-for="(item, index) in list" :key="index">
                    <ToolCard
                        size="mini"
                        :data="item"
                        @handleCard="openDetail(item)"
                    ></ToolCard>
                </div>

                <transition name="dialogFade">
                    <ToolMiniDetail v-if="visible && detailId" :id="detailId" @closeDialog="closeDialog"></ToolMiniDetail>
                </transition>
            </div>
            <div class="loading" v-show="scrollLoading">
                <i class="el-icon-loading"></i>
            </div>

            <!-- 分页 -->
            <div class="tool-list__pagination">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :hide-on-single-page="true"
                    :page-size="pageSize"
                    :current-page="pageNum"
                    :total="total"
                    @current-change="handlePageChange">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { openWindow } from '@/utils/utils';
import { getToolList, viewTool } from '@/api/tool';
import ToolCard from '@/views/components/ToolCard';
import ToolMiniDetail from './ToolMiniDetail';
import EmptyPage from '@/components/EmptyPage';

export default {
    name: 'ToolList',
    components: {
        ToolCard,
        ToolMiniDetail,
        EmptyPage
    },
    inject: ['backTop'],
    props: {
        type: {
            type: [String, Number],
            default: 2
        }
    },
    data: () => ({
        loading: true,
        scrollLoading: false,
        detailId: null,
        visible: false,
        total: 0,
        pageSize: 32,
        pageNum: 1,
        pages: 1,
        list: []
    }),
    computed: {
        ...mapState('app', ['scrollStatus']),
    },
    watch: {
        type: {
            handler() {
                this.loading = true;
                this.list = [];
                this.initPageParams();
                this.getToolList();
            },
            immediate:true
        },
        // scrollStatus() {
        //     if (!this.scrollLoading) {
        //         this.scroll();
        //     }
        // }
    },
    mounted() {
        // this.initPageParams();
        // this.getToolList();
    },
    methods: {
        initPageParams() {
            this.pageNum = sessionStorage.getItem(this.$route.path) || 1;
            this.pageSize = 32;
            this.total = 0;
            this.pages = 1;
        },
        handlePageChange(pageNum) {
            sessionStorage.setItem(this.$route.path, pageNum)
            this.pageNum = pageNum;
            this.backTop();
            this.getToolList();
        },
        async getToolList() {
            try {
                const params = {
                    tooltype: this.type,
                    pageSize: this.pageSize,
                    pageNum: this.pageNum
                };
                const { code, data } = await getToolList(params);
                if (code === 0) {
                    const add = data.result.map(item => {
                        return {
                            id: item.id,
                            title: item.title,
                            subtitle: item.synopsis,
                            follow: item.count, // 浏览量
                            image: item.logo,
                            url: item.toolurl,
                            isabroad: item.isabroad
                        };
                    });
                    // this.list = [...this.list, ...add];
                    this.list = add || [];
                    this.total = data.total;
                    this.pages = data.pages;
                }
            } catch (err) {
                throw err;
            } finally {
                this.loading = false;
                this.scrollLoading = false;
            }
        },
        // 无限滚动
        scroll() {
            if (this.pageNum > 100) return;
            if (this.pageNum >= this.pages) return;
            this.scrollLoading = true;
            this.pageNum++;
            this.getToolList();
        },
        openDetail(item) {
            const { id, url } = item;
            this.detailId = id;
            if (!id) return;
            viewTool({ id });
            if (url) {
                const aTag = document.createElement('a');
                let href = url;
                aTag.href = href;
                aTag.target = '_blank';
                aTag.click();
                return;
            }
            if (this.type === 5) {
                this.visible = true;
            } else {
                openWindow('/#/tool/detail/' + id);
            }
        },
        closeDialog() {
            this.visible = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.tool-list {
    padding-top: 20px;

    &__item {
        display: inline-block;
        width: 300px;
        margin-right: 25px;
        margin-top: 0;

        &:nth-child(4n + 4) {
            margin-right: 0;
        }

        &:nth-child(n + 5) {
            margin-top: 20px;
        }
    }

    &__pagination {
        margin-top: 45px;
        text-align: center;
    }
}

.loading {
    margin: 20px 0;
    text-align: center;
    font-size: 32px;
}

// 小屏
@include mq($small) {
    .tool-list {
        padding-top: 14px;
        &__item {
            width: 225px;
            margin-right: 15px;
            margin-top: 0;

            &:nth-child(4n + 4) {
                margin-right: 0;
            }

            &:nth-child(n + 5) {
                margin-top: 15px;
            }
        }

        &__pagination {
            margin-top: 45px;
            text-align: center;
        }
    }
}

.dialogFade-enter-active,
.dialogFade-leave-active {
    transition: opacity 0.4s;
}

.dialogFade-enter,
.dialogFade-leave-active {
    opacity: 0;
}
</style>
